import { render } from "./IngresoPreguntas2.vue?vue&type=template&id=6ee3007b&scoped=true"
import script from "./IngresoPreguntas2.vue?vue&type=script&lang=js"
export * from "./IngresoPreguntas2.vue?vue&type=script&lang=js"

import "./IngresoPreguntas2.vue?vue&type=style&index=0&id=6ee3007b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee3007b"]])

export default __exports__